import useSWR from 'swr';

import { ResponseGetMembersOfTenant, useAuth } from '@/features/auth';
import { axios } from '@/lib/axios';

export const APIgetMembersOfTenant = (tenantId: string | undefined): Promise<ResponseGetMembersOfTenant> | undefined => {
    if (!tenantId) return;
    return axios.get(`/tenant/${tenantId}/user`);
};

export const useGetMembersOfTenant = () => {
    const { tenant } = useAuth();
    return useSWR([tenant?.id, '/tenant/user'], APIgetMembersOfTenant);
};
